module.exports = __webpack_public_path__ + "img/forward-inactive.2a266a78.svg";